import React, { HTMLAttributes } from 'react'
import { ButtonSizeType, ButtonStyleType, ButtonThemeType, ButtonType } from '../_config/types'

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
    type?: ButtonType
    theme?: ButtonThemeType
    size?: ButtonSizeType
    styleType?: ButtonStyleType
    className?: string
    disabled?: boolean
    form?: string
    ref?: React.Ref<HTMLButtonElement>
}

const Button: React.FC<ButtonProps> = ({ children, type = 'button', theme = 'primary', size = 'md', styleType = '', className = '', disabled = false, form, ref, ...args }) => {
    const getTheme = () => {
        if (styleType == '') {
            switch (theme) {
                case 'secondary':
                    return 'bg-secondary text-white'
                case 'accent':
                    return 'bg-accent text-white'
                case 'neutral':
                    return 'bg-neutral text-white'
                case 'tertiary':
                    return 'bg-[#F4F4F4] text-black border border-[#C8C8C8]'
                case 'light':
                    return 'bg-white text-black border border-[#F4F4F4]'
                default:
                    return 'bg-primary text-secondary'
            }
        } else {
            switch (theme) {
                case 'secondary':
                    return 'bg-transparent text-secondary border border-secondary'
                case 'accent':
                    return 'bg-transparent text-accent border border-accent'
                case 'neutral':
                    return 'bg-transparent text-neutral border border-neutral'
                case 'tertiary':
                    return 'bg-transparent text-black border border-[#74788D]'
                case 'light':
                    return 'bg-transparent text-white border border-white'
                default:
                    return 'bg-transparent text-primary border border-primary'
            }
        }
    }

    const getSize = () => {
        switch (size) {
            case 'xxs':
                return 'text-[0.65rem] h-[1.5rem] gap-1 px-[0.75rem] rounded-[0.16rem] font-semibold'
            case 'xs':
                return 'text-[0.833rem] h-[2.083rem] gap-[0.625rem] px-[1.042rem] rounded-[0.417rem] font-semibold'
            case 'sm':
                return 'text-[0.625rem] h-[2rem] gap-1 px-[1.417rem] rounded-[0.25rem] font-semibold'
            case 'lg':
                return 'text-[1rem] h-[2.667rem] leading-[1.5rem] gap-1 px-[1.417rem] rounded-[0.25rem] font-semibold'
            case 'xl':
                return 'text-[1rem] h-[2.833rem] gap-1 px-[2.625rem] rounded-[0.333rem] font-semibold'
            default:
                return 'text-[1rem] gap-1 px-[2.625rem] py-[0.667rem] rounded-[0.25rem] font-semibold'
        }
    }

    return (
        <button ref={ref} type={type} className={`${getTheme()} ${getSize()} inline-flex items-center justify-center leading-none disabled:bg-slate-300 disabled:opacity-50 ${className}`} disabled={disabled} {...args} form={form}>
            {children}
        </button>
    )
}

export default Button
